import { Image, Result, Button, Form } from "antd";
import Password from "antd/es/input/Password";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  images_folder,
  doConfirmAccountReset,
  doConfirmAccountResetFinal,
  getURL,
} from "./client";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
const ConfirmReset = (props) => {
  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const reset_code = queryParameters.get("reset_code");
    const email = queryParameters.get("email");
    if (reset_code && email) {
      props.setSpin(true);
      doConfirmAccountReset({ reset_code: reset_code, email: email })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 1) {
            setResetCode(data.reset_code);
            setResetId(data.reset_id);
            setToken(data.token);
            setShowPasswordFields(true);
          } else {
            setVerificationError(true);
          }
        })
        .finally((func) => {
          props.setSpin(false);
        });
    } else {
      //navigate(getURL("/"));
    }
  });
  const [changeSuccess, setChangeSuccess] = useState(false);
  const [verificationError, setVerificationError] = useState(false);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [resetCode, setResetCode] = useState("");
  const [resetId, setResetId] = useState("");
  const [token, setToken] = useState("");
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 8,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 16,
      },
    },
  };
  const onFinish = (values) => {
    props.setSpin(true);
    const request = {
      reset_code: resetCode,
      password: values.password,
      uid: resetId,
      reset_id: resetId,
      token: token,
    };
    doConfirmAccountResetFinal(request)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setShowPasswordFields(false);
          setChangeSuccess(true);
        } else {
          setVerificationError(true);
        }
      })
      .finally((func) => {
        props.setSpin(false);
      });
  };

  return (
    <>
      <SiteHeader headerType="create-account" />
      <div className="sign-in-intro">
        <Image width={75} preview={false} src={images_folder("uk-flag.png")} />
        <h3>Confirm Password Change</h3>
      </div>
      {showPasswordFields && (
        <Form
          className="create-account-form"
          onFinish={onFinish}
          {...formItemLayout}
        >
          <Form.Item
            hasFeedback
            autoComplete="off"
            name="password"
            label="New Password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
              {
                min: 10,
                message: "Password length must be at least 10 characters",
              },
            ]}
          >
            <Password autoComplete="off" />
          </Form.Item>
          <Form.Item
            hasFeedback
            autoComplete="off"
            name="confirm-password"
            label="Confirm Password"
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      "The two passwords that you entered do not match!"
                    )
                  );
                },
              }),
            ]}
          >
            <Password autoComplete="off" />
          </Form.Item>
          <Button
            block
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Change Password
          </Button>
        </Form>
      )}
      {changeSuccess && (
        <Result
          status="success"
          title="Password Changed Successfully"
          subTitle="You may sign in now"
          extra={[
            <Link key="verify-complete" to="/">
              <Button type="primary" className="login-form-button">
                Sign in
              </Button>
            </Link>,
          ]}
        />
      )}
      {verificationError && (
        <Result
          status="warning"
          title="Password could not be reset."
          subTitle="Perhaps the password reset link has expired."
          extra={[
            <Link key="verify-reset" to={getURL("/forgot-password")}>
              <Button type="default" className="login-form-button">
                Request Password Reset
              </Button>
            </Link>,
          ]}
        />
      )}
      <SiteFooter />
    </>
  );
};
export default ConfirmReset;
